import LoadingSpinner from '../../../../../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import type { McaFetchStatusProps } from '../../types';

function McaFetchStatus({ message, spinnerHeight }: McaFetchStatusProps) {
    return (
        <>
            <LoadingSpinner color="var(--primary-purple)" height={spinnerHeight} />
            {message}
        </>
    );
}

export default McaFetchStatus;
